import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {EvidVidsModule} from '@catmodules/models/evid-vids/evid-vids.module';
import {FeatureEvidFunctionsWelcomeComponent} from '@catmodules/models/feature-evid-functions/components/feature-evid-functions-welcome/feature-evid-functions-welcome.component';
import {FeatureEvidVidsModule} from '@catmodules/models/feature-evid-vid/feature-evid-vid.module';
import {SlideInModalModule} from '@catmodules/widgets/slide-in-modal/slide-in-modal.module';
import {UIBaseModule} from '@catui/ui-base.module';
import {UIFormModule} from '@catuiform/ui-form.module';
import {FeatureEvidFunctionFormComponent} from './components/feature-evid-function-form/feature-evid-function-form.component';
import {FeatureEvidFunctionsService} from './services/feature-evid-functions.service';
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {LinkedEntitiesModule} from "@catmodels/linked-entities/linked-entities.module";
import {ParametersModule} from "@catmodels/parameters/parameters.module";

const publicComponents = [
  FeatureEvidFunctionFormComponent,
  FeatureEvidFunctionsWelcomeComponent,
];

const imports = [
  CommonModule,
  ReactiveFormsModule,
  UIFormModule,
  FeatureEvidVidsModule,
  EvidVidsModule,
  UIBaseModule,
  BrowserAnimationsModule,
  LinkedEntitiesModule,
  ParametersModule,
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [FeatureEvidFunctionsService];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class FeatureEvidFunctionModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/feature-evid-functions/feature-evid-function.module.ts